import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { configUrl } from "../config";
import { Features } from "../MarketingSiteComponents/Features";
import { Footer } from "../MarketingSiteComponents/Footer";
import { Header } from "../MarketingSiteComponents/Header";
import HelpSupportDialog from "../MarketingSiteComponents/HelpSupportDialog";
import getAllSubscriptionsService from "../services/OwnTestCreationServices/getAllSubscriptionsService";
import CollegePredictor from "./CollegePredictor";
import { HeroTS_Specific } from "./Hero";
import { TestPackages } from "./TestPackages";
import TopicPulse from "./TopicPulse";
// import CollegePredictor from "./CollegePredictor";


const NewHomeTS_Specific = () => {
    const navigate = useNavigate();
    axios.defaults.headers.common = {
        providerId: configUrl.MediNeerProviderId,
        contentProviderIds: configUrl.MediNeerContentProviderIds
    };
    // const { data: objectiveResponse, isLoading } = useGetAllObjective(
    //     "Objective",
    //     true,
    //     true,
    //     false
    // );
    const [objectives, setObjectives] = useState([]);
    const [subscriptions, setSubscriptions] = useState([]);
    const [CPsubscription, setCPSubscription] = useState([]);
    const [counsellingSubscription, setCounsellingSubscription] = useState([]);
    const [showCollegePredictor, setShowCollegePredictor] = useState(false);
    const [openTwoCardModal, setOpenTwoCardModal] = useState(false);
    const [isSubscriptionLoading, setIsSubscriptionLoading] = useState(true);
    const [openHelpSupport, setOpenHelpSupport] = useState(false);

    const packagesRef = useRef(null);

    const scrollToPackages = () => {

        if (packagesRef?.current) {
            packagesRef?.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    };

    useEffect(() => {
        const data = async () => {
            setIsSubscriptionLoading(true);

            try {
                const subscriptions = await getAllSubscriptionsService();

                const topicPulse = subscriptions.find(
                    x => x.code === "TopicPulse"
                );

                const collegePredictor = subscriptions.find(
                    x => x.code === "CollegePredictor"
                );

                const counselling = subscriptions.find(
                    x => x.code === "StudentCounselling"
                );

                if (topicPulse) {
                    const topicPulseData = {
                        ...topicPulse,
                        courseId: topicPulse.subscriptionTypeId,
                    };

                    delete topicPulseData.subscriptionTypeId;
                    setSubscriptions(topicPulseData);
                }

                if (collegePredictor) {
                    const cpData = {
                        ...collegePredictor,
                        courseId: collegePredictor.subscriptionTypeId,
                    };

                    delete cpData.subscriptionTypeId;
                    setCPSubscription(cpData);
                }

                if (counselling) {
                    const counsellingData = {
                        ...counselling,
                        courseId: counselling.subscriptionTypeId,
                    };

                    delete counsellingData.subscriptionTypeId;
                    setCounsellingSubscription(counsellingData);
                }
            } catch (error) {
                console.error(error);
            } finally {
                setIsSubscriptionLoading(false);
            }
        };

        data();
    }, []);

    // useEffect(() => {
    //     const data = async () => {
    //         const subscriptions = await getAllSubscriptionsService();
    //         const modifiedSubscription = {
    //             ...subscriptions[0],
    //             courseId: subscriptions[0].subscriptionTypeId,
    //         };
    //         const CPModifiedSubscription = {
    //             ...subscriptions[1],
    //             courseId: subscriptions[1].subscriptionTypeId,
    //         };
    //         delete modifiedSubscription.subscriptionTypeId;
    //         setSubscriptions(modifiedSubscription);
    //         delete CPModifiedSubscription.subscriptionTypeId;
    //         setCPSubscription(CPModifiedSubscription);
    //     }
    //     data()
    // }, []);

    const onHandleCourseList = async () => {
        const subscriptions = await getAllSubscriptionsService();
        // setSubscriptions(subscriptions);
        // Rename property before passing to navigation state
        const modifiedSubscription = {
            ...subscriptions[0],
            courseId: subscriptions[0].subscriptionTypeId,
        };
        delete modifiedSubscription.subscriptionTypeId;

        navigate('/medineer/test-series-list', {
            state: {
                // objectives,
                subscriptions: modifiedSubscription,
            },
        });
    }

    const handleShowSubcription = (subscriptionType) => {
        if (showCollegePredictor === subscriptionType) {
            setShowCollegePredictor(null);
            return;
        }
        setShowCollegePredictor(subscriptionType);
    }
    // useEffect(() => {
    //     if (objectiveResponse && objectiveResponse?.length > 0) {
    //         setObjectives(objectiveResponse);
    //     }
    // }, [objectiveResponse]);

    console.log("CPsubscription", CPsubscription, "counsellingSubscription", counsellingSubscription);
    return (
        <div>
            <Header onHandleExplore={() => onHandleCourseList()} onOpenHelpSupport={() => setOpenHelpSupport(true)} handleShowSubcription={handleShowSubcription} onOpenPackagesModal={() => setOpenTwoCardModal(true)} />
            <main>
                {/* <Hero onHandleExplore={() => onHandleCourseList()} handleShowSubscription={showCollegePredictor} onOpenPackagesModal={() => setOpenTwoCardModal(true)} onPricingClick={scrollToPackages} /> */}
                <HeroTS_Specific onHandleExplore={() => onHandleCourseList()} handleShowSubscription={showCollegePredictor} onOpenPackagesModal={() => setOpenTwoCardModal(true)} onPricingClick={scrollToPackages} />
                <div ref={packagesRef}>
                    <TestPackages
                        openTwoCardModal={openTwoCardModal}
                        setOpenTwoCardModal={setOpenTwoCardModal}
                        subscription={subscriptions}
                    />
                </div>
                <TopicPulse handleShowSubcription={handleShowSubcription} />
                <CollegePredictor handleShowSubcription={handleShowSubcription} />
                <Features />
                {/* <ServicePlansSection
                    onPricingClick={scrollToPackages}
                    onOpenCollegePredictor={() => setOpenTwoCardModal(true)}
                    collegePredictorSubscription={CPsubscription}
                    counsellingSubscription={counsellingSubscription}
                    isSubscriptionLoading={isSubscriptionLoading}
                />
                <ReviewSection setShowForm={scrollToPackages} /> */}
                {/* <HowItWorks /> */}
                {/* <WhyChooseUs /> */}
                <HelpSupportDialog
                    open={openHelpSupport}
                    onClose={() => setOpenHelpSupport(false)}
                />
            </main>
            <Footer onHandleExplore={() => onHandleCourseList()} />
        </div>
    );
}

export default NewHomeTS_Specific;
